import bronzeCapPng from '/img/lottery/bronze-cup.png';
import bronzeCapWebp from '/img/lottery/bronze-cup.webp';
import goldCapPng from '/img/lottery/gold-cup.png';
import goldCapWebp from '/img/lottery/gold-cup.webp';
import silverCapPng from '/img/lottery/silver-cup.png';
import silverCapWebp from '/img/lottery/silver-cup.webp';

const capImages = {
  1: {
    img: goldCapPng,
    webp: goldCapWebp,
    alt: 'gold cap',
    className: 'size-[64px] shrink-0',
  },
  2: {
    img: silverCapPng,
    webp: silverCapWebp,
    alt: 'silver cap',
    className: 'size-[40px] shrink-0',
  },
  3: {
    img: bronzeCapPng,
    webp: bronzeCapWebp,
    alt: 'bronze cap',
    className: 'size-[40px] shrink-0',
  },
};

export { capImages };
